// Compares an aggregated measure between two filter values on the same column
// e.g. compare Sales (sum) where Year=2013 vs Year=2014

import { extractDatePart } from "../../data/dateParts";

function aggregate(rows, measure, aggregation) {

  if (aggregation === "count") return rows.length;

  const values = rows
    .map(r => Number(r[measure]))
    .filter(v => !isNaN(v));

  if (!values.length) return null;

  switch (aggregation) {
    case "average":
      return values.reduce((a, b) => a + b, 0) / values.length;
    case "maximum":
      return Math.max(...values);
    case "minimum":
      return Math.min(...values);
    default:
      return values.reduce((a, b) => a + b, 0);
  }
}

export function computeCompare(data, { column, valueA, valueB, measure, aggregation = "sum", datePart } = {}) {

  if (!Array.isArray(data) || !data.length) {
    return { success: false, error: "No data available for compare." };
  }

  if (!column || valueA === undefined || valueB === undefined) {
    return { success: false, error: "compare requires a column and two values to compare." };
  }

  const resolve = row => datePart ? extractDatePart(row[column], datePart) : row[column];

  const rowsA = data.filter(r => String(resolve(r)) === String(valueA));
  const rowsB = data.filter(r => String(resolve(r)) === String(valueB));

  const aValue = aggregate(rowsA, measure, aggregation);
  const bValue = aggregate(rowsB, measure, aggregation);

  const change = (aValue !== null && bValue !== null) ? bValue - aValue : null;

  const pctChange = (change !== null && aValue)
    ? (change / Math.abs(aValue)) * 100
    : null;

  return {
    success: true,
    tool: "compare",
    column,
    measure,
    aggregation,
    a: { label: valueA, value: aValue, rows: rowsA.length },
    b: { label: valueB, value: bValue, rows: rowsB.length },
    change,
    pctChange,
  };
}
